import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/question.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "team-card-wraper" }
const _hoisted_3 = { class: "team-card-avatar" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "team-card-content-item" }
const _hoisted_6 = { class: "team-card-content-item-title" }
const _hoisted_7 = { class: "team-card-content-item-title-name" }
const _hoisted_8 = { class: "team-card-content-item-title-tooltip" }
const _hoisted_9 = { class: "team-card-content-item-value" }
const _hoisted_10 = { class: "content-wrapper" }
const _hoisted_11 = { class: "content-table" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "pagination" }

import {
  ref,
  computed,
  onMounted,
  onUnmounted,
} from "vue";
import ClueNum from "@/assets/img/clueNum.png";
import RateNum from "@/assets/img/rateNum.png";
import ValueNum from "@/assets/img/valueNum.png";
import CollisionNum from "@/assets/img/collisionNum.png";
import OutputNum from "@/assets/img/outputNum.png";
import store from "@/store";
import FollowStatusCom from "./followStatusCom.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'leadContent',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  // 列表数据
  listData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  // 列表数据总数
  listNums: {
    type: Number,
    default: 0,
  },
  // 当前线索类型
  leadsType: {
    type: String,
    default: "",
  },
  // 当前线索的数据概览
  overviewData: {
    type: Object,
    default: () => {
      return {};
    },
  },
},
  emits: ["updatePageList"],
  setup(__props, { emit: __emit }) {

const props = __props;

// 自适应宽度
const columnWidth = ref("120px");

const emits = __emit;

// 数据概览的卡片列表
const dataOverviewList = computed(() => {
  // 保养线索
  if (props.leadsType === "0") {
    return maintenanceLeadOverviewList.value;
  } else if (props.leadsType === "3") {
    // 维修线索
    return faultLeadOverviewList.value;
  } else if (props.leadsType === "1") {
    // 保险线索
    return accidentLeadOverviewList.value;
  } else if (props.leadsType === "2") {
    // 续保线索
    return insuranceLeadOverviewList.value;
  }
  return maintenanceLeadOverviewList.value;
});

// 数据概览——保养线索
const maintenanceLeadOverviewList = computed(() => {
  return [
    {
      dataIcon: ClueNum,
      dataName: "下发线索量",
      tooltip: "统计指定时间内下发开业门店的线索量",
      num: props.overviewData?.maintenanceLeads?.sendLeadsNum || 0,
    },
    {
      dataIcon: RateNum,
      dataName: "30天进站率",
      tooltip:
        "分母：指定时间内下发开业门店的线索量；分子：分母中下发线索后30天内回站的车辆数",
      num: props.overviewData?.maintenanceLeads?.entranceRate || "0.00%",
    },
    {
      dataIcon: ValueNum,
      dataName: "配件产值提升",
      tooltip:
        "统计指定时间内进站率提升相关的配件营收，产值=下发线索量 ×（进站率-6%) × 客单价520元",
      num:
        (props.overviewData?.maintenanceLeads?.accessoriesValue || "0") + "万",
    },
    {
      dataIcon: OutputNum,
      dataName: "工单总产值",
      tooltip: "统计指定时间内，下发线索中30天内回站的工单产值（包含索赔金额）",
      num: (props.overviewData?.maintenanceLeads?.outputValue || "0") + "万",
    },
  ];
});

// 数据概览——维修线索
const faultLeadOverviewList = computed(() => {
  return [
    {
      dataIcon: ClueNum,
      dataName: "下发线索量",
      tooltip: "统计指定时间内下发开业门店的线索量",
      num: props.overviewData?.faultLeads?.sendLeadsNum || 0,
    },
    {
      dataIcon: RateNum,
      dataName: "30天进站率",
      tooltip:
        "分母：指定时间内下发开业门店的线索量；分子：分母中下发线索后30天内回站的车辆数",
      num: props.overviewData?.faultLeads?.entranceRate || "0.00%",
    },
    {
      dataIcon: ValueNum,
      dataName: "轻微碰撞产值",
      tooltip: "产值=指定时间内故障描述为轻微碰撞且跟进成功的数量 × 5000元",
      num: (props.overviewData?.faultLeads?.minorOutputValue || "0") + "万",
    },
    {
      dataIcon: CollisionNum,
      dataName: "严重碰撞产值",
      tooltip: "产值=指定时间内故障描述为严重碰撞且跟进成功的数量 × 40000元",
      num: (props.overviewData?.faultLeads?.seriousOutputValue || "0") + "万",
    },
  ];
});

// 数据概览——保险线索
const accidentLeadOverviewList = computed(() => {
  return [
    {
      dataIcon: ClueNum,
      dataName: "下发线索量",
      tooltip: "统计指定时间内下发开业门店的线索量",
      num: props.overviewData?.accidentLeads?.sendLeadsNum || 0,
    },
    {
      dataIcon: RateNum,
      dataName: "30天进站率",
      tooltip:
        "分母：指定时间内下发开业门店的线索量；分子：分母中下发线索后30天内回站的车辆数",
      num: props.overviewData?.accidentLeads?.entranceRate || "0.00%",
    },
  ];
});

// 数据概览——续保线索
const insuranceLeadOverviewList = computed(() => {
  return [
    {
      dataIcon: ClueNum,
      dataName: "下发线索量",
      tooltip: "统计指定时间内下发开业门店的线索量",
      num: props.overviewData?.insuranceLeads?.sendLeadsNum || 0,
    },
    {
      dataIcon: RateNum,
      dataName: "续保成功单数",
      tooltip: "统计指定下发时间内续保成功的数量",
      num: props.overviewData?.insuranceLeads?.insuranceSuccessNum || "0",
    },
  ];
});

// 页面分页数据
const paginationData = computed(() => store.state.leadsView.pageParams);

// 切换每页大小
const handleSizeChange = (pageSize: number) => {
  paginationData.value.pageNO = 1;
  paginationData.value.pageSize = pageSize;
  store.commit("leadsView/setPageParams", {
    pageNO: paginationData.value.pageNO,
    pageSize: paginationData.value.pageSize,
  });
  getTableList();
};

const handleCurrentChange = (currentPage: number) => {
  paginationData.value.pageNO = currentPage;
  store.commit("leadsView/setPageParams", {
    pageNO: paginationData.value.pageNO,
    pageSize: paginationData.value.pageSize,
  });
  getTableList();
};

const getTableList = () => {
  // console.log("paginationData :>> ", paginationData);
  emits("updatePageList");
};

// 根据浏览器宽度计算table列的宽度
const updateColumnWidth = () => {
  const zoomLevel = window.innerWidth / 1440; // 计算缩放比例
  const calculatedWidth = 120 * zoomLevel; // 计算宽度
  columnWidth.value = `${calculatedWidth}px`; // 动态设置宽度
};

onMounted(() => {
  updateColumnWidth();
  document.addEventListener("resize", updateColumnWidth);
});

onUnmounted(() => {
  document.removeEventListener("resize", updateColumnWidth);
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataOverviewList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "team-card",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: item.dataIcon
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.dataName), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: item.tooltip,
                  placement: "top"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                  ])),
                  _: 2,
                  __: [2]
                }, 1032, ["content"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.num), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_table, {
          data: __props.listData,
          height: "100%",
          stripe: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "leadsId",
              label: "线索ID",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "busLeadsId",
              label: "业务系统ID",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "sendLeadsTime",
              label: "线索接收时间",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "distributeLeadsTime",
              label: "下发时间",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "vin",
              label: "VIN",
              "min-width": "240",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "brand",
              label: "品牌",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "rfsName",
              label: "大区名称",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "macName",
              label: "小区名称",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "ascCode",
              label: "门店Code",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            _createVNode(_component_el_table_column, {
              prop: "serviceStationName",
              label: "门店简称",
              width: columnWidth.value,
              align: "center"
            }, null, 8, ["width"]),
            (__props.leadsType === '3')
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "faultPhenomenon",
                  label: "故障现象",
                  width: columnWidth.value,
                  align: "center"
                }, null, 8, ["width"]))
              : _createCommentVNode("", true),
            (__props.leadsType === '1')
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  prop: "isMC",
                  label: "是否严重碰撞",
                  width: columnWidth.value,
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.isMC === "1"
                  ? "是"
                  : scope.row.isMC === "0"
                  ? "否"
                  : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["width"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              prop: "followStatus",
              label: "跟进状态",
              width: columnWidth.value,
              align: "center",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (scope.row.followStatus)
                  ? (_openBlock(), _createBlock(FollowStatusCom, {
                      key: 0,
                      status: scope.row.followStatus
                    }, null, 8, ["status"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12))
              ]),
              _: 1
            }, 8, ["width"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_pagination, {
          "current-page": paginationData.value.pageNO,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((paginationData.value.pageNO) = $event)),
          "page-size": paginationData.value.pageSize,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((paginationData.value.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          small: "",
          layout: "sizes, prev, pager, next, jumper",
          total: __props.listNums,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ])
  ])), [
    [_directive_loading, __props.loading]
  ])
}
}

})